import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, margin } from '@rexlabs/styling';
import { MaybeLink } from './maybe-link';
var defaultStyles = StyleSheet({
  icon: _objectSpread({}, margin.styles({
    target: 'navigation.subItem',
    right: 'xs'
  })),
  prefix: _objectSpread({}, margin.styles({
    target: 'navigation.subItem',
    left: 'm'
  }))
});
export function SubItem(_ref) {
  var to = _ref.to,
      label = _ref.label,
      groupId = _ref.groupId,
      _ref$activeMatches = _ref.activeMatches,
      activeMatches = _ref$activeMatches === void 0 ? [] : _ref$activeMatches,
      onClick = _ref.onClick,
      Icon = _ref.Icon,
      Suffix = _ref.Suffix,
      attributes = _ref.attributes;
  var s = useStyles(defaultStyles);
  return /*#__PURE__*/React.createElement(MaybeLink, {
    to: to,
    groupId: groupId,
    activeMatches: activeMatches,
    onClick: onClick,
    attributes: attributes
  }, Icon && /*#__PURE__*/React.createElement(Box, _extends({}, s('icon'), {
    alignItems: 'center'
  }), /*#__PURE__*/React.createElement(Icon, {
    size: "m"
  })), /*#__PURE__*/React.createElement(Box, _extends({}, s('label'), {
    flex: 1,
    alignItems: "center"
  }), label), Suffix && /*#__PURE__*/React.createElement(Box, _extends({}, s('prefix'), {
    alignItems: "center"
  }), /*#__PURE__*/React.createElement(Suffix, {
    size: "m"
  })));
}